export default function(tag = 'div') {
    return new HTML(tag)
}

/**
 * Pipelined class for building simple html objects
 */
export class HTML {
    
    /**
     * Creates initial empty element
     * @param tag
     */
    constructor(tag) {
        this.element = document.createElement(tag)
        this.instanceOfHTML = true
    }
    
    /**
     * Bind event listener to element
     * @param {string} name
     * @param {function} callback Arguments: {Event, HTMLElement}
     * @param {mixed} args
     * @returns {HTML}
     */
    on(name, callback, ...args) {
        this.element.addEventListener(name, event => {
            callback(event, this.element, ...args)
        })
        return this
    }
    
    /**
     * Indirectly bind event listeners list
     * @param {function|[function]} listeners
     * @returns {HTML}
     */
    defineListeners(...listeners) {
        listeners = listeners instanceof Array ? listeners : [listeners]
        listeners.map(listener => {
            this.on(listener.event, listener.callback)
        })
        return this
    }
    
    /**
     * Assign multiple attributes for element
     * @param {object} elementPropsObject
     * @returns {HTML}
     */
    attr(elementPropsObject) {
        for (let property in elementPropsObject) {
            if (elementPropsObject.hasOwnProperty(property)) {
                this.element.setAttribute(property, elementPropsObject[property])
            }
        }
        return this
    }
    
    /**
     * Appends one or multiple nodes inside element
     * @param {Node|Array|HTML} nodes
     * @returns {HTML}
     */
    append(...nodes) {
        nodes.map(node => {
            if (node instanceof Array) {
                node.map(n => {
                    if (n instanceof Node) {
                        this.element.appendChild(n)
                    } else if (n instanceof HTML) {
                        this.element.appendChild(n.element)
                    }
                })
            } else if (node instanceof HTML) {
                this.element.appendChild(node.element)
            } else if (node instanceof Node) {
                this.element.appendChild(node)
            } else if (typeof node === 'string') {
                var wrapper = document.createElement('div')
                wrapper.innerHTML = node
                var kids = Array.prototype.slice.call(wrapper.children)
                kids.map(e => {
                    this.element.appendChild(e)
                })
            }
        })
        
        return this
    }
    
    /**
     * Prepends one or multiple nodes inside element
     * @param {Node|Array|HTML} nodes
     * @returns {HTML}
     */
    prepend(...nodes) {
        nodes.map(node => {
            if (node instanceof Array) {
                node.map(n => {
                    if (n instanceof Node) {
                        this.element.insertBefore(n, this.element.firstChild)
                    } else if (n instanceof HTML) {
                        this.element.insertBefore(n.element, this.element.firstChild)
                    }
                })
            } else if (node instanceof HTML) {
                this.element.insertBefore(node.element, this.element.firstChild)
            } else if (node instanceof Node) {
                this.element.insertBefore(node, this.element.firstChild)
            } else if (typeof node === 'string') {
                var wrapper = document.createElement('div')
                wrapper.innerHTML = node
                var kids = Array.prototype.slice.call(wrapper.children)
                kids.reverse().map(e => {
                    this.element.insertBefore(e, this.element.firstChild)
                })
            }
        })
        
        return this
    }
    
    /**
     * Fill element with non-html content
     * @param str
     * @returns {HTML}
     */
    content(str) {
        this.element.innerHTML = str
        return this
    }
    
    /**
     * Shortcut for classes assignment.
     * @param {string} str Class or Classes to add
     * @param {boolean} replace Whether to replace or add classes
     * @returns {HTML}
     */
    classes(str, replace = false) {
        if (replace) {
            this.element.className = str
        } else {
            var cl = this.element.className
            this.element.className = cl.length > 0 ? cl + ' ' + str : str
        }
        return this
    }
    
    /**
     * Mutate or do something directly to HTML element inside callback function
     * @param {function} callback
     * @returns {HTML}
     */
    mutate(callback) {
        if (typeof callback === 'function') {
            callback(this.element)
        }
        return this
    }
    
    /**
     * Returns processed HTML element
     * @returns {Node}
     */
    render() { return this.element }
}
